import createSvgIcon from '../createSvgIcons'

/**
 * @ignore - internal component.
 */
export default createSvgIcon(
  [
    <path
      key={0}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.73223 8.73223C4.20107 8.26339 4.83696 8 5.5 8H7C7.55228 8 8 8.44772 8 9C8 9.55228 7.55228 10 7 10H5.5C5.36739 10 5.24021 10.0527 5.14645 10.1464C5.05268 10.2402 5 10.3674 5 10.5V19.5C5 19.6326 5.05268 19.7598 5.14645 19.8536C5.24022 19.9473 5.36739 20 5.5 20H13C13.1326 20 13.2598 19.9473 13.3536 19.8536C13.4473 19.7598 13.5 19.6326 13.5 19.5V10.5C13.5 10.3674 13.4473 10.2402 13.3536 10.1464C13.2598 10.0527 13.1326 10 13 10H11.5C10.9477 10 10.5 9.55228 10.5 9C10.5 8.44772 10.9477 8 11.5 8H13C13.663 8 14.2989 8.26339 14.7678 8.73223C15.2366 9.20107 15.5 9.83696 15.5 10.5V19.5C15.5 20.163 15.2366 20.7989 14.7678 21.2678C14.2989 21.7366 13.663 22 13 22H5.5C4.83696 22 4.20107 21.7366 3.73223 21.2678C3.26339 20.7989 3 20.163 3 19.5V10.5C3 9.83696 3.26339 9.20107 3.73223 8.73223Z"
      fill="currentColor"
    />,
    <path
      key={1}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.75 15C11.75 15.5523 11.3023 16 10.75 16H7.75C7.19772 16 6.75 15.5523 6.75 15C6.75 14.4477 7.19772 14 7.75 14H10.75C11.3023 14 11.75 14.4477 11.75 15Z"
      fill="currentColor"
    />,
    <path
      key={2}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.75 2C13.1977 2 12.75 2.44772 12.75 3V5.25C12.75 5.80228 13.1977 6.25 13.75 6.25C14.3023 6.25 14.75 5.80228 14.75 5.25V3C14.75 2.44772 14.3023 2 13.75 2Z"
      fill="currentColor"
    />,
    <path
      key={3}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.5 9.75C21.5 9.19772 21.0523 8.75 20.5 8.75H18.25C17.6977 8.75 17.25 9.19772 17.25 9.75C17.25 10.3023 17.6977 10.75 18.25 10.75H20.5C21.0523 10.75 21.5 10.3023 21.5 9.75Z"
      fill="currentColor"
    />,
    <path
      key={4}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.2569 4.24309C18.8664 3.85256 18.2332 3.85256 17.8427 4.24309L16.2302 5.85559C15.8397 6.24611 15.8397 6.87928 16.2302 7.2698C16.6207 7.66033 17.2539 7.66033 17.6444 7.2698L19.2569 5.6573C19.6474 5.26678 19.6474 4.63361 19.2569 4.24309Z"
      fill="currentColor"
    />,
    <path
      key={5}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.5 8.5C8.22386 8.5 8 8.72386 8 9C8 9.27614 8.22386 9.5 8.5 9.5H10C10.2761 9.5 10.5 9.27614 10.5 9C10.5 8.72386 10.2761 8.5 10 8.5H8.5ZM6 9C6 7.61929 7.11929 6.5 8.5 6.5H10C11.3807 6.5 12.5 7.61929 12.5 9C12.5 10.3807 11.3807 11.5 10 11.5H8.5C7.11929 11.5 6 10.3807 6 9Z"
      fill="currentColor"
    />,
  ],
  'ClipboardRemove'
)
